{
  "settings": {
    "title": "Account Settings",
    "subtitle": "Manage your email, password, and account status.",
    "needHelp": "Need help? Join our Discord"
  },
  "changeEmail": {
    "title": "Change Email Address",
    "subtitle": "Changing your email will require you to re-confirm your email address. You will be logged out of all sessions.",
    "newEmailLabel": "New Email Address",
    "newEmailPlaceholder": "Enter new email",
    "currentPasswordLabel": "Current Password",
    "currentPasswordPlaceholder": "Enter current password",
    "submitButton": "Update Email Address",
    "submittingButton": "Updating..."
  },
  "changePassword": {
    "title": "Change Password",
    "subtitle": "Update your password. You will stay logged in on this device.",
    "currentPasswordLabel": "Current Password",
    "currentPasswordPlaceholder": "Enter current password",
    "newPasswordLabel": "New Password",
    "newPasswordPlaceholder": "Enter new password",
    "confirmPasswordLabel": "Confirm New Password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "submitButton": "Change Password",
    "submittingButton": "Updating..."
  },
  "closeAccount": {
    "title": "Close Account",
    "subtitle": "Permanently deactivate your account. If you have an active subscription, it will be cancelled. This action cannot be easily undone.",
    "openButton": "I want to close my account",
    "warning": "⚠️ Warning: This will deactivate your account, cancel any active subscription, log you out of all sessions and we will not refund for cancelled subscriptions. Your data will be retained but your account will be inaccessible.",
    "passwordLabel": "Your Password",
    "passwordPlaceholder": "Enter your password",
    "confirmLabel": "Type",
    "confirmCode": "CLOSE MY ACCOUNT",
    "confirmLabelEnd": "to confirm",
    "confirmPlaceholder": "CLOSE MY ACCOUNT",
    "cancelButton": "Cancel",
    "submitButton": "Close Account Permanently",
    "submittingButton": "Closing..."
  },
  "contactUs": {
    "title": "Contact Us",
    "body": "Contact us at",
    "discordName": "Flipping Pal Discord",
    "bodyEnd": "or join our Discord community for questions."
  }
}
